<template>
  <div class="club-points-history-table-row">
    <points
      :value="points"
      :is-add-mode="isAddMode"
    />

    <cell-label class="club-points-history-table-row__date">
      Операция от {{ date }}
    </cell-label>

    <div
      v-if="isAddMode"
      class="club-points-history-table-row__table"
    >
      <cell-label>
        Остаток
      </cell-label>
      <cell-value>
        {{ sum | price }}
      </cell-value>
    </div>

    <div
      class="club-points-history-table-row__table"
    >
      <cell-label>
        {{ isAddMode ? 'Начисление' : 'Списание' }}
      </cell-label>
      <cell-value>
        <history-description
          :description="description"
          :order-number="orderNumber"
          :receipt="receipt"
        />
      </cell-value>
    </div>

    <div
      v-if="isAddMode"
      class="club-points-history-table-row__table"
    >
      <cell-label>
        Сгорают
      </cell-label>
      <cell-value>
        {{ burnsAt }}
      </cell-value>
    </div>
  </div>
</template>

<script>
import CellLabel from '@/components/account/club-table/label.vue';
import CellValue from '@/components/account/club-table/value.vue';
import Points from '@/components/account/club-table/points.vue';
import HistoryDescription from '@/components/account/club-table/history-description.vue';

export default {
  name: 'club-points-history-table-row',

  components: {
    CellLabel,
    CellValue,
    Points,
    HistoryDescription,
  },

  props: {
    points: {
      type: Number,
      required: true,
    },
    isAddMode: {
      type: Boolean,
      default: true,
    },
    date: {
      type: String,
      default: '',
    },
    sum: {
      type: Number,
      required: true,
    },
    description: {
      type: String,
      default: '',
    },
    burnsAt: {
      type: String,
      default: '',
    },
    orderNumber: {
      type: String,
      default: '',
    },
    receipt: {
      type: String,
      default: '',
    },
  },
}
</script>

<style lang="scss">
  .club-points-history-table-row {
    padding: 14px 21px;
    border-bottom: 1px solid $gray_lu;

    &:last-child {
      border: 0;
    }

    &__date {
      margin-bottom: 12px;
    }

    &__table &-label {
      flex: 0 0 104px;
      margin-right: 10px;
    }

    &__table {
      display: flex;
      margin-bottom: 16px;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }
</style>